/* eslint-disable @typescript-eslint/naming-convention */
export enum ToastDuration {
	Fast = 3000,
	Slow = 10000
}
